import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import client from '../contentful';
import './Works.css';

function Works() {
  const [works, setWorks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client.getEntries({ content_type: 'work', order: '-fields.worksPageSequence' })
      .then((response) => {
        setWorks(response.items);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  }, []);

  if (loading) return <div>THIS IS WORKS.JS LOADING</div>;

  return (
    <div className="works-page">
      <div className="works-grid">
        {works.map((work) => {
          const { title, year, materials, dimensions, images } = work.fields;
          const imageUrl = images && images[0] ? 'https:' + images[0].fields.file.url : '';
          return (
            <Link to={`/work/${work.sys.id}`} key={work.sys.id} className="work-item">
              <div className="work-image">
                {imageUrl && <img src={imageUrl} alt={title} />}
              </div>
              <div className="work-info">
               <span className="work-title">{title}, <span className="work-year">{year}</span></span>
                <span className="work-meta">{materials}</span>
                <span className="work-meta">{dimensions}</span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}

export default Works;